/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';
import type useActes from '@/hooks/useActes';
import type useActeIndividus from '@/hooks/useActeIndividus';
import type useMentionAnts from '@/hooks/useMentionAnts';
import type { Acte, ActeIndividu, MentionAnts, TypeActe } from '@/types';

import ActeBlock from '../../SelectionActe/ActeBlock';
import MentionBlock from '../../SelectionActe/MentionBlock';
import PersonneBlock from '../../SelectionActe/PersonneBlock';

interface Props {
  typeActe: TypeActe;
  onTypeActeChange: (type: TypeActe) => void;
  selectedActe: Acte | null;
  onActeSelected: (acte: Acte) => void;
  selectedIndividu: ActeIndividu | null;
  onIndividuSelected: (individu: ActeIndividu) => void;
  selectedMention: MentionAnts | null;
  onMentionSelected: (mention: MentionAnts) => void;
  actes: ReturnType<typeof useActes>;
  acteIndividus: ReturnType<typeof useActeIndividus>;
  mentionAnts: ReturnType<typeof useMentionAnts>;
  onNewSearch: () => void;
}

const SelectionStep = ({
  typeActe,
  onTypeActeChange,
  selectedActe,
  onActeSelected,
  selectedIndividu,
  onIndividuSelected,
  selectedMention,
  onMentionSelected,
  actes,
  acteIndividus,
  mentionAnts,
  onNewSearch,
}: Props) => (
  <div
    style={{
      display: 'flex',
      gap: '1em',
      width: '100%',
      height: '100%',
      alignItems: 'stretch',
    }}
  >
    <div
      style={{
        flex: '0 0 55%',
        minWidth: 0,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <ActeBlock
        typeActe={typeActe}
        actes={actes}
        selectedActe={selectedActe}
        onTypeActeChange={onTypeActeChange}
        onActeSelected={onActeSelected}
        onNewSearch={onNewSearch}
      />
    </div>
    <div
      style={{
        flex: 1,
        minWidth: 0,
        minHeight: 0,
        height: '100%',
        display: 'grid',
        gridTemplateRows: '1fr 1fr',
        gap: '1em',
      }}
    >
      <div style={{ minHeight: 0, overflow: 'hidden' }}>
        <PersonneBlock
          selectedActe={selectedActe}
          acteIndividus={acteIndividus}
          selectedIndividu={selectedIndividu}
          onIndividuSelected={onIndividuSelected}
        />
      </div>
      <div style={{ minHeight: 0, overflow: 'hidden' }}>
        <MentionBlock
          selectedIndividu={selectedIndividu}
          mentionAnts={mentionAnts}
          selectedMention={selectedMention}
          onMentionSelected={onMentionSelected}
        />
      </div>
    </div>
  </div>
);

export default SelectionStep;
